import { FaqUrl, WyshHelpCenterUrl } from "config";

export const openChat = () => {
  window.open(WyshHelpCenterUrl, "_blank");
};

export const openFaqLink = () => {
  window.open(FaqUrl, "_blank");
};
